import styled from '@emotion/styled';

export const Wrapper = styled.div`
  width: 100%;
  max-width: 430px;
  position: absolute;
  background-color: ${props => props.theme.colors.white};
  border-radius: ${props => props.theme.borderRadius.default};

  display: flex;
  flex-direction: column;
  border: none;
  padding: 0px 30px 0px 30px;
  align-items: center;

  @media all and (max-width: ${props => props.theme.breakpoints.s}) {
    border-radius: 0;
    padding: 0px 20px;
  }

  input[type='submit'],
  input[type='button'] {
    outline: none;
    cursor: pointer;
  }

  > .loading-wrapper {
    z-index: 1000;
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    position: relative;
    .loading-gif {
      position: absolute;
      top: 90px;
    }
  }
`;

export const FormTitle = styled.h1`
  font-size: 25px;
  margin-top: 15px;
  font-weight: bold;
  text-align: center;

  @media all and (max-width: ${props => props.theme.breakpoints.s}) {
    font-size: ${props => props.theme.cardsTitleFontSize.m};
    line-height: ${props => props.theme.cardsTitleLineHeight.m};
    margin-top: 20px;
  }
`;

export const CloseModalButton = styled.div`
  position: absolute;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 6px;

  top: 16px;
  right: 16px;
  cursor: pointer;

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const LoginForm = styled.form`
  margin: 0px;
  padding-bottom: 20px;
  width: 100%;

  display: flex;
  flex-direction: column;
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: row;
  height: 60px;
  border: 1px solid black;
  border-radius: 6px;
  width: 100%;
  opacity: 0.5;
  position: relative;
  margin-bottom: 20px;

  @media all and (max-width: ${props => props.theme.breakpoints.s}) {
    height: 40px;
  }

  & > svg {
    position: absolute;
    right: 23px;
    top: calc(50% - 8px);

    width: 20px;

    cursor: pointer;
  }

  & > span {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    border-right: 1px solid;
    width: 15%;
  }
`;

export const SocialField = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 60px;
  width: 100%;
  border: none;
  border-radius: 10px;

  @media all and (max-width: ${props => props.theme.breakpoints.s}) {
    height: 40px;
  }

  > span {
    background-color: white;
    width: 15%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    border-right: none;
  }

  > label {
    color: white;
    font-weight: bold;
    text-transform: uppercase;
    width: 85%;
    text-align: center;
    cursor: pointer;
  }

  &.google {
    background-color: #4285f4;
    margin-bottom: 5px;
    border-right: 1px solid #4285f4;
    cursor: pointer;

    @media all and (max-width: ${props => props.theme.breakpoints.s}) {
      margin-bottom: 20px;
    }

    span {
      border: 1px solid #4285f4;
    }
  }

  &.facebook {
    margin-bottom: 5px;
    background-color: #3b5998;
    cursor: pointer;

    span {
      background-color: #263c68;
    }
  }

  &.apple {
    background-color: #282828;
    cursor: pointer;

    span {
      background-color: #000000;
    }
  }
`;

export const Subtitle = styled.div`
  margin: 10px auto;
  cursor: pointer;
  text-align: center;

  &:hover {
    color: ${props => props.theme.colors.blue};
  }

  @media all and (max-width: ${props => props.theme.breakpoints.s}) {
    font-size: ${props => props.theme.textSize.xs};
  }
`;

export const NormalFieldSet = styled.div`
  input:not([type='submit']) {
    border: none;
    outline: none;
    padding: 0px 70px 0px 19px;
    background: none;
    width: 85%;
  }

  .helper-section {
    > span {
      display: flex;
      > .action {
        cursor: pointer;
        margin-left: 5px;
        cursor: pointer;
        &:hover {
          color: ${props => props.theme.colors.blue};
        }
      }
    }
  }
`;

export const Button = styled.input`
  background-color: ${props => props.theme.colors.blue};
  width: 100%;
  border-radius: 10px;
  height: 60px;
  border: none;
  color: white;
  font-weight: ${props => props.theme.fontWeight.button};

  @media all and (max-width: ${props => props.theme.breakpoints.s}) {
    height: 40px;
  }
`;

export const SocialFieldSet = styled.div`
  margin-top: 15px;
`;

export const RegisteredTitle = styled.div`
  margin: 20px 0;
  text-align: center;
  display: flex;
  align-items: center;

  &::before,
  &::after {
    content: '';
    display: block;
    width: 50px;
    height: 1px;
    background-color: ${props => props.theme.colors.black};
  }

  &::before {
    margin-right: 14px;
  }

  &::after {
    margin-left: 14px;
  }

  @media all and (max-width: ${props => props.theme.breakpoints.s}) {
    font-size: ${props => props.theme.textSize.s};
    margin: 30px 0 20px;
  }
`;

export const ButtonOutline = styled(Button)`
  background: white;
  border: 1px solid ${props => props.theme.colors.stroke};
  border-radius: ${props => props.theme.borderRadius.default};
  width: 100%;
  max-width: 230px;
  color: ${props => props.theme.colors.black};
`;
